import React from 'react';
import Navigation from './navigation'; // Import navigation jsx


function App() {
  return (
    <div className="App">
    <Navigation />
    </div>
  );
}

export default App;
